module.exports = __webpack_public_path__ + "static/media/Login.68101887.png";